import { fetchToken } from "../../../common/FetchCookie";
import {
  BASE_URL,
  CANDIDATE,
  CORE,
  CORE_JOB_TITLES,
  PUBLIC_TITLES,
} from "../../../common/URLs";

export const fetchJobTitles = async () => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_TITLES}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchPublicJobTitles = async (keyword = "") => {
  const query = keyword ? `?keyword=${encodeURIComponent(keyword)}` : "";
  const url = `${BASE_URL}/${CANDIDATE}/${PUBLIC_TITLES}${query}`; // Proxy path

  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addJobTitles = async (newJobTitle) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_TITLES}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",

        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newJobTitle),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteJobTitle = async (uuid) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${CORE}/${CORE_JOB_TITLES}/${uuid}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Error deleting job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job title: " + error.message);
  }
};

export const updateJobTitle = async (uuid, title, status) => {
  try {
    const token = await fetchToken();

    const response = await fetch(
      `${BASE_URL}/${CORE}/${CORE_JOB_TITLES}/${uuid}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: title, // Send title
          status: status, // Send status
        }),
      }
    );

    // console.log("Updating Job Title:", { title, status, uuid });

    if (!response.ok) {
      throw new Error("Error updating job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job title: " + error.message);
  }
};
